import { EarningsInsight, formatTicker } from '@api';
import { SkeletonLoader } from '@design/components/skeleton-loader/SkeletonLoader';
import { AssetLogoContainer } from '@terminal/components/asset-logo-container/AssetLogoContainer';
import { useEntity } from '@terminal/react-query-hooks/entities/useEntities';
import { POSTHOG_TRACKING_SOURCES } from '@terminal/services/tracking/posthog/constants';
import { EarningsInsightIcon } from '@terminal/widgets/earnings-insight-drawer/earnings-insight-widget/components/earnings-insight-icon/EarningsInsightIcon';

import styles from './Cell.module.scss';

export const CompanyCell = ({
  entityTag,
  variant = 'primary',
  earningsInsight,
  isEarningsInsightsFetching = false,
}: {
  entityTag: string;
  variant?: 'primary' | 'secondary';
  earningsInsight?: EarningsInsight;
  isEarningsInsightsFetching?: boolean;
}) => {
  const { data, isFetching, isError } = useEntity(entityTag);
  const isPrimary = variant === 'primary';

  if (isFetching || isEarningsInsightsFetching) {
    return (
      <SkeletonLoader
        areas={[
          {
            styles: {
              width: '100%',
              height: '36px',
              borderRadius: '8px',
            },
          },
        ]}
      />
    );
  }

  if (isError || !data?.data) {
    return null;
  }

  const formattedTicker = formatTicker(data.data);
  const name = data.data.name_short || data.data.name;

  const title = isPrimary ? formattedTicker : name;
  const subtitle = isPrimary ? name : formattedTicker;

  return (
    <div className={styles.root}>
      <AssetLogoContainer entity={data.data} />
      <div className={styles.flexColumn}>
        <div className={styles.titleLabel}>{title}</div>
        <div className={styles.subtitleLabel}>{subtitle}</div>
      </div>
      <div className={styles.selfAlignEnd}>
        {!!earningsInsight && (
          <EarningsInsightIcon
            entityTag={entityTag}
            size={20}
            earningsInsight={earningsInsight}
            source={POSTHOG_TRACKING_SOURCES.THEME_OVERVIEW}
          />
        )}
      </div>
    </div>
  );
};
